import React, { useCallback, useEffect, useState } from "react";
import { Card, Col, Table, Form, Row } from "react-bootstrap";
 
import { useNavigate } from "react-router-dom";
import { Badge, Dropdown } from "react-bootstrap";

import toast from "react-hot-toast";
import { TableLoaderRow, TableEmptyRow } from "../components/TableLoader";
import Pagination from "../components/Pagination";
import PageTitle from "../layouts/PageTitle";
import {
  blockUser,
  getUserList,
} from "../../services/UserServices/UserService";
 
import ConfirmationDeleteAccount from "../components/Modal/ConfirmationDeleteAccount";
import debounce from "lodash/debounce";

export default function UnEnroll(props) {

    /* dummy data record of user */
  let userss=[
{phone:8607551726,
  click:"Contacted",
    status:"Payment Completed",
    createdAt:"21 Aug 2025"  
},
{phone:8607551726,
  click:"Enroll In Progress",
    status:"Not Interested",
    createdAt:"21 Aug 2025"  

},

{phone:8607551726,
  click:"Contacted",
    status:"Payment Completed",
    createdAt:"21 Aug 2025"  

},
{phone:8607551726,
  click:"Enroll In Progress",
    status:"Not Interested",
    createdAt:"21 Aug 2025"  

},

{phone:8607551726,
  click:"Contacted",
    status:"Payment Completed",
    createdAt:"21 Aug 2025"  

},
{phone:8607551726,
  click:"Enroll In Progress",
    status:"Not Interested",
    createdAt:"21 Aug 2025"  

},
{phone:8607551726,
  click:"Enroll In Progress",
    status:"Not Interested",
    createdAt:"21 Aug 2025"  

},
 

  ]







  const navigate = useNavigate();
  const [deleteAccount, setDeleteAccount] = useState(false);
  const [loader, setLoader] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [jobId, setJobId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  //  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState("");
  const [sortBy,setSortBy]=useState("");
  const [isBlocked, setIsBlocked] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);


  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  async function handleTableList() {
    setLoader(true);
    try {
      const res = await getUserList(currentPage, 10, search);
      setTableData(res?.data?.data?.users);
      setTotalItems(res?.data?.data?.count);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoader(false);
    }
  }



  async function handleBlockComponent() {
    setActionLoading(true);
    try {
      await blockUser({ userId: jobId, isBlocked });
      handleTableList();
      setDeleteAccount(false);
      toast.success("User blocked successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setActionLoading(false);
    }
  }

  const handleTableListDebounced = useCallback(
    debounce(() => {
      handleTableList();
    }, 400),
    [search,currentPage]
  );

  // useEffect to trigger search whenever input changes
  useEffect(() => {
    handleTableListDebounced();

    // Cleanup debounce on unmount or next effect
    return () => handleTableListDebounced.cancel();
  }, [search, currentPage]);

  async function handleUnblockComponent(id) {
    setActionLoading(true);
    try {
      await blockUser({ userId: id, isBlocked: false });
      handleTableList();
      setDeleteAccount(false);
      toast.success("User unblocked successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setActionLoading(false);
    }
  }

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if (!!tableData && tableData?.length === 0 && !loader) {
    <div className="justify-content-center d-flex my-5 ">
      Sorry, Data Not Found!
    </div>;
  }

 
  







  return (
    <div className="qx-page">
      <PageTitle pageTitle="Unenrolled Users" subtitle="Users who have unenrolled from the platform" />

      <Card className="qx-filter-card border-0 shadow-none mb-4">
        <Row className="g-3 qx-filter-grid align-items-end">
          <Col lg={4} md={6} sm={12}>
            <Form.Group className="mb-0">
              <Form.Label>Search</Form.Label>
              <div className="qx-search-wrap">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by name, phone-number"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                {search && (
                  <button
                    type="button"
                    onClick={() => setSearch("")}
                    className="qx-search-clear"
                    aria-label="Clear search"
                  >
                    ×
                  </button>
                )}
              </div>
            </Form.Group>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <Form.Group className="mb-0">
              <Form.Label>Sort By</Form.Label>
              <Form.Select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                <option value="">Default</option>
                <option value="name">Name</option>
                <option value="createdAt">Created At</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      </Card>

      <Card className="qx-table-card">
        <Card.Body>
          <Table responsive>
            <thead style={{ color: "#A60000" }}>
              <tr>
                <th>
                  <strong>S.NO</strong>
                </th>
                <th>
                  <strong> Phone Number </strong>
                </th>
                <th>
                  <strong>Created At</strong>
                </th>
                <th>
                  <strong>Click Status</strong>
                </th>
                <th>
                  <strong>Status</strong>
                </th>
                <th>
                  <strong>Action</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {loader ? (
                <TableLoaderRow colSpan={6} />
              ) : !userss?.length ? (
                <TableEmptyRow colSpan={6} message="No unenrolled users found" />
              ) : (
                userss?.map((tension, index) => (
                      <tr style={{ color: "#A60000" }} key={index}>
                        <td>{index + 1 + currentPage * itemsPerPage}</td>
                      
                       
                        
                        <td>
                          <span className="w-space-no">

                            {/*tension?.countryCode*/} 
                            {tension?.phone}
                          </span>
                        </td>
                        <td>
                          <span className="w-space-no">
                            {new Date(tension?.createdAt).toLocaleDateString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "long",
                                year: "numeric",
                              }
                            )}
                          </span>
                        </td>
               
                               <td>
                          <span className="w-space-no">

                    
                            {tension?.phone}
                          </span>
                        </td>


                        <td>
                          {tension?.isBlocked ? (
                            <Badge bg="" className="badge-danger">
                              Not Interested
                            </Badge>
                          ) : (
                            <Badge bg="" className="badge-success">
                                Payment Completed
                            </Badge>
                          )}
                        </td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="info light"
                              className="qx-action-toggle"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  navigate(`/user-details/${tension._id}`, {
                                    state: { tension },
                                  });
                                  //  navigate(`/user-details/${tension._id}`)
                                }}
                              >
                                View
                              </Dropdown.Item>

                              {/* ✅ Block / Unblock Option */}
                              <Dropdown.Item
                                onClick={() => {
                                  if (tension?.isBlocked) {
                                    handleUnblockComponent(tension?._id);
                                    setIsBlocked(false);
                                  } else {
                                    setDeleteAccount(true);
                                    setJobId(tension?._id);
                                    setIsBlocked(true);
                                  }
                                }}
                              >
                                {tension?.isBlocked ? "Payment Completed" : "Not Interested"}
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                ))
              )}
            </tbody>
          </Table>

          {!loader && userss?.length > 0 && (
            <Pagination
              pageCount={totalPages}
              pageValue={currentPage}
              setPage={setCurrentPage}
              total={totalItems}
              pageSize={itemsPerPage}
            />
          )}
        </Card.Body>
      </Card>
      <ConfirmationDeleteAccount
        show={deleteAccount}
        onHide={() => setDeleteAccount(false)}
        onDelete={handleBlockComponent}
        type="user"
      />
    </div>
  );
}
